import { render, staticRenderFns } from "./IconContainer.vue?vue&type=template&id=6952f34e"
import script from "./IconContainer.vue?vue&type=script&lang=js"
export * from "./IconContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports